import Button from '@mui/material/Button'
import React from 'react'
import { getButtonTestId } from './getButtonTestId'

/** @notExported */
interface YellowOutlinedButtonProps {
  /** Action to be performed when the button is clicked. */
  clickAction: () => void
  /** Whether the button is valid. */
  valid: boolean
  /** Label of the button. */
  label: React.ReactNode
  /** Icon of the button. */
  icon?: React.ReactElement
  /** Whether to remove the margin. */
  noMargin?: boolean
  /** Whether to set the button's width to 100%. */
  noFullWidth?: boolean
  /** Test id of the button. */
  testId?: string
}

/**
 * Yeallow outined button.
 *
 * @returns Yellow outline button component.
 * @notExported
 * @category Buttons
 */
const YellowOutlinedButton: React.FC<YellowOutlinedButtonProps> = ({
  clickAction,
  valid,
  label,
  icon,
  noMargin,
  noFullWidth,
  testId,
}) => {
  const resolvedTestId = getButtonTestId({ fallback: 'button-yellow-outlined', label, testId })

  return (
    <Button
      data-testid={resolvedTestId}
      variant="outlined"
      startIcon={icon}
      disabled={!valid}
      onClick={() => clickAction()}
      style={{ width: noFullWidth ? 'inherit' : '100%', marginTop: noMargin ? 0 : '10px' }}
      color="warning"
    >
      {label}
    </Button>
  )
}

export default YellowOutlinedButton
